import React, { useState, useEffect } from 'react';
import Pagination from '../pagination/Pagination';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';


const Downloads = () => {
  const [agendas, setAgendas] = useState([]);
  const [years, setYears] = useState([]);
  const [selectedAgenda, setSelectedAgenda] = useState('--- Select Agenda ---');
  const [selectedYear, setSelectedYear] = useState('--- Select Year ---');
  const [pdfFile, setPdfFile] = useState(null);
  const [downloads, setDownloads] = useState([]);
  const [show, setShow] = useState(false);
  const [pagination, setPagination] = useState({ start: 0, end: 10 });
  const [showPerPage] = useState(10);
 const dist = sessionStorage.getItem("dist");
  // Fetch Agendas
  // const fetchAgendas = async () => {
  //   const res = await axios.get("https://lionsdirectoryapi.emedha.in/download/api/api/agendas");
  //   setAgendas(res.data);
  // };

    const fetchAgendas = async () => {
    const res = await axios.get(
      `https://lionsdirectoryapi.emedha.in/download/api/api/agendas?dist=${dist}`
    );
    setAgendas(res.data);
  };



  // // Fetch Years
  // const fetchYears = async () => {
  //   const res = await axios.get("https://lionsdirectoryapi.emedha.in/download/api/api/years");
  //   setYears(res.data);
  // };


    const fetchYears = async () => {
    const res = await axios.get(
      `https://lionsdirectoryapi.emedha.in/download/api/api/years?dist=${dist}`
    );
    setYears(res.data);
  };
  
  



  // Fetch all Downloads
  // const fetchDownloads = async () => {
  //   const res = await axios.get("https://lionsdirectoryapi.emedha.in/download/api/api/downloads");
  //   setDownloads(res.data);
  // };

  const fetchDownloads = async () => {
  const res = await axios.get(
    `https://lionsdirectoryapi.emedha.in/download/api/api/downloads?dist=${dist}`
  );
  setDownloads(res.data);
};

  // Post New Download Data
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedAgenda || selectedAgenda === '--- Select Agenda ---') {
      return alert('Please select a valid Agenda');
    }
    if (!selectedYear || selectedYear === '--- Select Year ---') {
      return alert('Please select a valid Year');
    }
    if (!pdfFile) {
      return alert('Please upload a PDF file');
    }

    const formData = new FormData();
    formData.append('agenda', selectedAgenda);
    formData.append('year', selectedYear);
    formData.append('file', pdfFile);
    formData.append('dist', dist); 

    try {
      await axios.post('https://lionsdirectoryapi.emedha.in/download/api/api/downloads', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      alert('File uploaded successfully');
      setShow(false);
      fetchDownloads();
    } catch (error) {
      console.error('Error uploading file:', error);
      alert('Error uploading file');
    }
  };

  // Delete Download Data
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this download?')) {
      await axios.delete(`https://lionsdirectoryapi.emedha.in/download/api/api/downloads/${id}`);
      alert('Download deleted successfully');
      fetchDownloads();
    }
  };

  // Pagination change
  const onChangePagination = (start, end) => {
    setPagination({ start, end });
  };

  useEffect(() => {
    fetchAgendas();
    fetchYears();
    fetchDownloads();
  }, []);

  return (
    <>
      <Button variant="warning" onClick={() => setShow(true)}>
        Add
      </Button>

      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Download</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <select
              className="form-control"
              onChange={(e) => setSelectedAgenda(e.target.value)}
            >
              <option>--- Select Agenda ---</option>
              {agendas.map((agenda) => (
                <option key={agenda.id} value={agenda.agenda_name}>
                  {agenda.agenda_name}
                </option>
              ))}
            </select>

            <br />

            <select
              className="form-control"
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              <option>--- Select Year ---</option>
              {years.map((year) => (
                <option key={year.id} value={year.year}>
                  {year.year}
                </option>
              ))}
            </select>

            <br />

            <input
              type="file"
              className="form-control"
              accept=".pdf"
              onChange={(e) => setPdfFile(e.target.files[0])}
            />

            <br />

            <button type="submit" className="btn btn-danger form-control">
              Submit
            </button>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="table-container" style={{ marginTop: '1rem' }}>
        <table className="styled-table table table-bordered">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Agenda</th>
              <th>Year</th>
              <th>PDF</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {downloads.slice(pagination.start, pagination.end).map((data, index) => (
              <tr key={data.id}>
                 <td>{pagination.start + index + 1}</td>
                <td>{data.agenda}</td>
                <td>{data.year}</td>
                <td>
                  <a href={`${data.pdf_url}`} target="_blank" rel="noopener noreferrer">
                    View PDF
                  </a>
                </td>
                <td>
                  <button className="btn btn-danger" onClick={() => handleDelete(data.id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <Pagination page={showPerPage} onChangePagination={onChangePagination} total={downloads.length} />
      </div>
    </>
  );
};

export default Downloads;
